<script setup lang="ts">
import { formatList } from "~/utilities/format"
import { keys } from "~/utilities/injection"

const { contributors } = useProductContributors()

const contributorsString = computed(() => {
  if (!contributors.value?.length)
    return ""

  return formatList(contributors.value.map(({ details }) => {
    const { firstname, lastname, role } = details ?? {}
    return `${firstname} ${lastname} (${role})`
  }))
})

const isDark = inject(keys.isDark)
</script>

<template>
  <div class="font-national2 text-base md:text-lg/6">
    <p
      v-if="contributorsString"
      class="font-extrabold text-platform-black"
      :class="{ 'text-white': isDark }"
    >
      SKREVET AV:
      <span class="font-normal">
        {{ contributorsString }}
      </span>
    </p>
  </div>
</template>
